"use client";

import { AlertTriangle } from "lucide-react";

export default function Error({
  error,
}: {
  error: Error & { digest?: string };
}) {
  return (
    <div className="flex min-h-[calc(100vh-10rem)] items-center justify-center p-4">
      <div className="w-full max-w-lg overflow-hidden rounded-3xl border border-neutral-200 bg-white text-neutral-900 shadow-2xl dark:border-neutral-900 dark:bg-neutral-950 dark:text-white">
        <div className="flex flex-col items-center justify-center gap-5 p-10 text-center">
          <AlertTriangle className="h-10 w-10 text-red-500" />
          <div className="space-y-2">
            <h1 className="text-lg font-semibold text-neutral-900 dark:text-white">
              Something went wrong!
            </h1>
            <p className="text-sm text-neutral-600 dark:text-neutral-300">
              {error.message}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
